import { useEffect } from "react";

import { useGeneratePublicProcessLink } from "../../../../../hooks/process-link";

/**
 * Esse componente apenas chama o useEffect, pois não é possivel renderizar dentro da aba do Modeler
 */
function ModelerSectionGerarLinkPublico({ element, saveProcessLinkOnModeler }) {
  const { data: linkGerado, isLoading: linkLoad } =
    useGeneratePublicProcessLink({});

  useEffect(() => {
    if (!linkGerado) return;

    saveProcessLinkOnModeler && saveProcessLinkOnModeler(element, linkGerado);
  }, [linkGerado, saveProcessLinkOnModeler]);

  return <></>;
}

export default ModelerSectionGerarLinkPublico;
